module.exports = __webpack_public_path__ + "img/file-zipper.e2e00724.svg";